import { useState } from 'react'
import { Routes, Route, BrowserRouter, useLocation, Navigate } from 'react-router-dom'
import Login from './views/auth/Login'
import Register from './views/auth/Register'
import WinefactsHeader from './views/base/WinefactsHeader';
import { useAuthApp } from './app/auth';

// import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import './App.css'
import MainWrapper from './layouts/MainWrapper';
import PrivateRoute from './layouts/PrivateRoute';
import ActivateAccount from './views/auth/ActivateAccount';
import ForgotPassword from './views/auth/ForgotPassword';
import CreatePassword from './views/auth/CreatePassword';
import ChangePassword from './views/auth/ChangePassword';
import ProductNameManagement from './views/winefacts/ProductNameManagement';
import Logout from './views/auth/Logout';
import Product from './views/winefacts/Product';
import ProductNutrients from './views/winefacts/ProductNutrients';
import ProductIngredients from './views/winefacts/ProductIngredients';
import ProductIngredientsDetails from './views/winefacts/ProductIngredientDetails';
import Dashboard from './views/winefacts/Dashboard';
import ProductUpdate from './views/winefacts/ProductUpdate';
import ProductDetails from './views/winefacts/ProductDetails';
import Profile from './views/winefacts/Profile';
import TermsAndConditions from './views/winefacts/TermsAndConditions';
import ProductOverviewHeader from './views/base/ProdcutOverviewHeader';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY } from './utils/constant';
import Spendings from './views/winefacts/Spendings';
// import { AxiosProvider } from './context/AxiosContext';


function AppRoutes() {
  const location = useLocation();

  // Define routes where AlternativeHeader should be used
  const useAlternativeHeader =
    location.pathname.startsWith("/product-overview"); // |
    // location.pathname.startsWith("/dashboard");

  const GOOGLE_RECAPTCHA_SITE_KEY = REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;


  return (
    <>
      {/* {renderHeader()} */}
      {/* <WinefactsHeader /> */}
      
        {useAlternativeHeader ? <ProductOverviewHeader /> : <WinefactsHeader />}
        <div className="main-content">
        <Routes>
            {/* Public routes (not in Mainwrapper) */}
            {/* User authentication */}
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={
              <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_RECAPTCHA_SITE_KEY}>
                <Register />
              </GoogleReCaptchaProvider>} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/spendings" element={<Spendings />} />

            {/* User account management */}
            <Route path="/activate/account/:uidb64/:token" element={<ActivateAccount />}></Route>
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/create-new-password" element={<CreatePassword />} />
            {/* Product overview - must be public accessible */}
            <Route path="/product-overview/:hashedId" element={<ProductDetails />} />
            {/* Conditions & data protection ordinance */}
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
          {/* Protected routes (wrapped in MainWrapper) */}
          <Route element={<MainWrapper />}>
            {/* Winefacts Components */}
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/product-names" element={<PrivateRoute><ProductNameManagement /></PrivateRoute>} />
            <Route path="/create-product/:hashedId?" element={<PrivateRoute><Product /></PrivateRoute>} />
            <Route path="/product-nutrients/:hashedId" element={<PrivateRoute><ProductNutrients /></PrivateRoute>} />
            <Route path="/product-ingredients/:hashedId" element={<PrivateRoute><ProductIngredients /></PrivateRoute>} />
            <Route path="/product-ingredients-details/:hashedId" element={<PrivateRoute><ProductIngredientsDetails /></PrivateRoute>} />
            <Route path="/update-product/:hashedId" element={<PrivateRoute><ProductUpdate /></PrivateRoute>} />
            <Route path="/user-profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
          </Route>
        </Routes>
        </div>
    </>
  );
};

export default AppRoutes;
